var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_321_3962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.16683 14.6666H3.16683C2.81321 14.6666 2.47407 14.5262 2.22402 14.2761C1.97397 14.0261 1.8335 13.6869 1.8335 13.3333V8.66665C1.8335 8.31302 1.97397 7.97389 2.22402 7.72384C2.47407 7.47379 2.81321 7.33331 3.16683 7.33331H5.16683M9.8335 5.99998V3.33331C9.8335 2.80288 9.62278 2.29417 9.24771 1.9191C8.87264 1.54403 8.36393 1.33331 7.8335 1.33331L5.16683 7.33331V14.6666H12.6868C13.0084 14.6703 13.3204 14.5576 13.5654 14.3493C13.8105 14.1411 13.9719 13.8513 14.0202 13.5333L14.9402 7.53331C14.9692 7.34222 14.9563 7.1471 14.9024 6.96148C14.8485 6.77586 14.7549 6.60418 14.6281 6.45832C14.5012 6.31247 14.3442 6.19593 14.1679 6.11679C13.9915 6.03765 13.8001 5.99779 13.6068 5.99998H9.8335Z",
    stroke: "#83C803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_3962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.edb0c93afdfb5d531bb00bdbfca05e38.svg";
export { ForwardRef as ReactComponent };